<template>
  <div class="default-layout">
    <div
      id="viewport"
      class="w-100 relative"
    >
      <orders-list />
    </div>
  </div>
</template>
<script>
import OrdersList from '../components/OrdersList.vue';

export default {
    components: {
        OrdersList
    },
}
</script>
